import React, { useLayoutEffect, useState } from 'react';

/**
 * Shared heart part meter (map overview + brief battle flash).
 */
export function ExploreUnknownHeartProgressBar({
  variant,
  imageSrc,
  collected,
  setsCompleted = 0,
  charges = 0,
  targetParts,
  regionLabel,
  tooltipTitle,
  tooltipBody,
  setsCompletedAriaLabel,
  chargesAriaLabel,
  mode,
  fromParts,
  toParts,
}) {
  const isFlash = mode === 'battle-flash';
  const [fillParts, setFillParts] = useState(isFlash ? fromParts : collected);

  useLayoutEffect(() => {
    if (!isFlash) {
      setFillParts(collected);
      return undefined;
    }
    const id = requestAnimationFrame(() => setFillParts(toParts));
    return () => cancelAnimationFrame(id);
  }, [isFlash, fromParts, toParts, collected]);

  const displayParts = isFlash ? fillParts : collected;
  const pct = (Math.min(targetParts, Math.max(0, displayParts)) / targetParts) * 100;
  const countLabel = isFlash
    ? `${Math.round(toParts)}/${targetParts}`
    : `${collected}/${targetParts}`;

  const hostClass =
    mode === 'battle-flash'
      ? `battle-eu-heart-flash-host battle-eu-heart-flash-host--${variant}`
      : `explore-unknown-heart-bar-wrap explore-unknown-heart-bar-tooltip-host explore-unknown-heart-bar-wrap--${variant}`;

  return (
    <div
      className={hostClass}
      role={isFlash ? 'status' : 'group'}
      aria-live={isFlash ? 'polite' : undefined}
      aria-label={regionLabel}
      tabIndex={0}
    >
      <div className="explore-unknown-heart-tooltip" role="tooltip" aria-hidden="true">
        <p className="explore-unknown-heart-tooltip-title">{tooltipTitle}</p>
        <p className="explore-unknown-heart-tooltip-body">{tooltipBody}</p>
      </div>
      <div className="explore-unknown-heart-icon-stack">
        <img src={imageSrc} alt="" className="explore-unknown-heart-bar-icon" />
        {mode === 'map' && setsCompleted > 0 ? (
          <span className="explore-unknown-heart-sets-badge" aria-label={setsCompletedAriaLabel}>
            {setsCompleted}
          </span>
        ) : null}
        {mode === 'map' && charges > 0 ? (
          <span className="explore-unknown-heart-sets-badge explore-unknown-ep-charges-badge" aria-label={chargesAriaLabel}>
            {charges}
          </span>
        ) : null}
      </div>
      <div className="explore-unknown-heart-track">
        <div
          className={`explore-unknown-heart-fill explore-unknown-heart-fill--${variant}`}
          style={{ width: `${pct}%` }}
        />
      </div>
      <span className="explore-unknown-heart-count-slot" aria-hidden="true">
        <span className="explore-unknown-heart-count">{countLabel}</span>
      </span>
    </div>
  );
}
